const pixelsTracking = {
    metaGeneralTracking: function(){
        const metaPixelTrackingGeneral = `<!-- Meta Pixel Code -->
        <script>
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1770077120090761');
        fbq('track', 'PageView');
        </script>
        <noscript><img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=1770077120090761&ev=PageView&noscript=1"
        /></noscript>
        <!-- End Meta Pixel Code -->`;

        document.getElementsByTagName("head")[0].innerHTML += metaPixelTrackingGeneral;
    },
    metaWelcomPageScript: function(){
        const metaWelcomPageScript = `<!-- Meta Pixel Code Welcome Page -->
        <script>
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1770077120090761');
        fbq('track', 'PageView');
        fbq('track', 'Step3');
        </script>
        <noscript><img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=1770077120090761&ev=PageView&noscript=1"
        /></noscript>
        <!-- End Meta Pixel Code Welcome Page -->`;

        document.getElementsByTagName("head")[0].innerHTML += metaWelcomPageScript;
    },
    metaCreatePasswordPageScript: function(){
        const metaCreatePasswordPageScript = `<!-- Meta Pixel Code Create Password Page -->
        <script>
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1770077120090761');
        fbq('track', 'PageView');
        fbq('track', 'Step6');
        </script>
        <noscript><img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=1770077120090761&ev=PageView&noscript=1"
        /></noscript>
        <!-- End Meta Pixel Code Create Password Page -->`;

        document.getElementsByTagName("head")[0].innerHTML += metaCreatePasswordPageScript;
    },
    googlePixelTrackingScript: function(){
        const googlePixelTrackingScript = `<!-- Google tag (gtag.js) --> 
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-988306579"></script> 
        <script> 
        window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'AW-988306579'); 
        </script>        
        <!-- End Google tag (gtag.js) -->`;

        document.getElementsByTagName("head")[0].innerHTML += googlePixelTrackingScript;
    }
};